import {makeChannelOptionHtml} from "./ChannelOptionHtml";

export function makeMakemytripChannelOptionHtml() {
    const innerHtml = 'MakeMyTrip';
    const html = makeChannelOptionHtml(innerHtml, [
        'background: #008EC9;',
        'color: white;',
        'font-weight: bold;'
    ]);
    return html;
}
